import {
  Text,
  GreyGrey10,
  GreyGrey30,
  GreyGrey70,
  GreyGrey80,
  Link,
  LinkProps,
  Primary13SemiBold,
  Primary13Regular,
  Box,
  Flex,
  Grid
} from '@sequencehq/core-components'

export const OutstandingInvoicesItem = ({
  firstColumnText,
  secondColumnText,
  thirdColumnText,
  indicatorIconColor,
  to
}: {
  firstColumnText: string
  secondColumnText: string
  thirdColumnText: string
  indicatorIconColor: string
  to: LinkProps['to']
}) => {
  return (
    <Grid
      as={Link.Unstyled}
      to={to}
      target="_blank"
      templateColumns="repeat(2, 1fr)"
      height="32px"
      borderBottom={`1px solid ${GreyGrey30}`}
      _last={{
        border: 'none'
      }}
      _hover={{
        backgroundColor: GreyGrey10
      }}
    >
      <Flex alignItems="center" gap={3}>
        <Box
          w={2}
          h={2}
          borderRadius="full"
          backgroundColor={indicatorIconColor}
        />
        <Text {...Primary13Regular} color={GreyGrey80}>
          {firstColumnText}
        </Text>
      </Flex>

      <Grid templateColumns="repeat(2, 1fr)" alignContent="center">
        <Text {...Primary13Regular} color={GreyGrey70} pl={6}>
          {secondColumnText}
        </Text>
        <Text
          {...Primary13SemiBold}
          color={GreyGrey70}
          textAlign="right"
          fontWeight="600"
        >
          {thirdColumnText}
        </Text>
      </Grid>
    </Grid>
  )
}
